import type { EditorAPI } from '../types';
import { findParentNodeOfType, findSelectedNodeOfType } from '@atlaskit/editor-prosemirror/utils';
import type { Node } from 'prosemirror-model';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';

export const getSelectedNodeLocalId = (editorAPI?: EditorAPI): string | undefined => {
	if (!editorAPI) {
		return undefined;
	}

	const result: { node: Node | null } = { node: null };

	// Access the editor state to get the selected node
	editorAPI.core.actions.execute(({ tr }) => {
		const { selection } = tr;

		// Get extension node types from the schema
		const schema = tr.doc.type.schema;
		const { inlineExtension, extension, bodiedExtension, multiBodiedExtension } = schema.nodes;
		const nodeTypes = [extension, bodiedExtension, inlineExtension, multiBodiedExtension];

		const selectedExtension = findSelectedNodeOfType(nodeTypes)(selection);
		if (selectedExtension?.node.attrs.extensionType !== 'com.atlassian.ecosystem') {
			return null;
		}

		if (selectedExtension) {
			result.node = selectedExtension.node;
			return null;
		}

		const parentExtension = findParentNodeOfType(nodeTypes)(selection);
		if (parentExtension) {
			result.node = parentExtension.node;
			return null;
		}

		if (selection instanceof NodeSelection) {
			if (nodeTypes.includes(selection.node.type)) {
				result.node = selection.node;
			}
		}

		return null;
	});

	if (!result.node) {
		return undefined;
	}

	const attrs = result.node.attrs as {
		extensionType?: string;
		localId?: string;
		parameters?: { localId?: string };
	};

	return attrs.localId || attrs.parameters?.localId;
};
